import { render, staticRenderFns } from "./area_list.vue?vue&type=template&id=af4f9492&scoped=true&"
import script from "./area_list.vue?vue&type=script&lang=js&"
export * from "./area_list.vue?vue&type=script&lang=js&"
import style0 from "./area_list.vue?vue&type=style&index=0&id=af4f9492&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af4f9492",
  null
  
)

export default component.exports